
import React from 'react';

export default function UserInformationPage2() 
{
    return ( 
        <> 
            <div class="row">
                <div class="col-1">
                    <a href="#"><img class="card-icon" src="./images/add.svg" alt="create team" border="0"/></a>
                </div>
                <div class="col">
                    To create a new Team, click on the Add Team icon. Enter your Team name, description, and action item prefix (up to 4 letters). 
                    The new Team will appear here in the User Panel.
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-1">
                    <a href="#"><img class="card-icon" src="./images/request.svg" alt="join team" border="0"/></a>
                </div>
                <div class="col">
                    Users can send a Join-Request to a Team by clicking this icon to the left and entering the Team name. Then Team administrators
                    can decide whether to accept the request.
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-1">
                    <a href="#"><img class="card-icon" src="./images/history.svg" alt="history" border="0"/></a>
                </div>
                <div class="col">
                    Here you will find a history of your activities, with the most recent listed on-top. Both Team Lists and Actions also have their own
                    history events.
                </div>
            </div>
           
            <div class="row mt-2">
                <div class="col-1">
                    <a href="#"><img class="card-icon" src="./images/settings.svg" alt="settings" border="0"/></a>
                </div>
                <div class="col">
                    Here are your User settings. Please note that the only unique item is your Username. Your First and Last Name are used for display 
                    and logging. Your Mobile Number and Email are used in Team Invitations as an alternate means to find you in addition to your Username.
                </div>
            </div>

        </> 
    );
}
